// MOCK data source for the landing page (frontend-only).

export const seo = {
  title: "Квартирный стилист — хоумстейджинг",
  description:
    "Хоумстейджинг. Быстро и недорого подготовлю вашу квартиру для аренды или быстрой продажи. Комплектация, меблировка, декорирование.",
  keywords:
    "хоумстейджинг, хоум стейджинг, подготовка квартиры, аренда, продажа, Москва",
  ogTitle: "Квартирный стилист — хоумстейджинг",
  ogDescription:
    "Подготовка квартиры для аренды или быстрой продажи. Комплектация, меблировка, декорирование.",
  ogImage: "",
  yandexVerification: "",
  googleVerification: "",
  canonical: "",
};

// Later we can replace with backend API calls.

export const brand = {
  name: "Квартирный стилист",
  logoUrl: "/logo.png",
  person: "Оксана Фурсова",
  role: "дипломированный хоумстейджер и колорист",

  // Header phone — используется в шапке сайта
  headerPhoneDisplay: "+7(903)718-70-47",
  headerPhoneRaw: "+79037187047",

  // Остальные контакты должны приходить из бэкенда (MongoDB)
  // contactPhoneDisplay, contactPhoneRaw, telegramHandle, telegramUrl, whatsappUrl, etc.
};

export const nav = [
  { id: "about", label: "ОБО МНЕ" },
  { id: "services", label: "УСЛУГИ И ЦЕНЫ" },
  { id: "how", label: "КАК ЭТО РАБОТАЕТ" },
  { id: "portfolio", label: "ПОРТФОЛИО" },
  { id: "contact", label: "КОНТАКТЫ" },
];

export const hero = {
  h1: "Хоумстейджинг. Быстро подготовлю вашу квартиру для сдачи в аренду или продажи",
  subline: "Комплектация, меблировка, декорирование: 3-6 недель",
  statCards: [
    { value: "+20%", label: "к стоимости\nаренды" },
    { value: "+5-15%", label: "к стоимости\nпродажи" },
    { value: "Гораздо быстрее", label: "сдать / продать" },
  ],
  photoLabel: "Фото Оксаны",
  photoUrl: "/dummy/oksana_dummy.jpg",
  about: [
    "Оксана Фурсова - дипломированный хоумстейджер и\nколорист. Превращу вашу квартиру в уютное и\nгармоничное пространство.",
    "Посетители с большей вероятностью захотят ее снять или\nкупить. А фотографии квартиры на досках объявлений\nгарантированно выделят ее на фоне аналогов.",
  ],
};

export const benefits = {
  title: "Зачем нужен профессиональный стейджинг?",
  subtitle:
    "Цель — сделать объект привлекательным и выгодным на фоне конкурентов: быстрее выйти на сделку и показать квартиру в лучшем свете (вживую и на фото).",
  cards: [
    {
      title: "Сокращение времени продажи/аренды",
      desc: "Убираю причины, из‑за которых квартира «зависает» в объявлениях месяцами: свет, ощущение пространства, функционал, чистота кадра.",
    },
    {
      title: "Повышение стоимости",
      desc: "Правильные акценты и комплектация помогают воспринимать объект дороже — и это отражается в финальной цене.",
    },
    {
      title: "Экономия бюджета",
      desc: "Использую недорогой, но качественный сегмент и готовые решения — чтобы 2–3× снизить стоимость оформления.",
    },
    {
      title: "Полный цикл (если нужно — под ключ)",
      desc: "От концепции и сметы до закупок, логистики, сборки и финальной стилизации под фото и показы.",
    },
  ],
  bullets: [
    "ускорение сдачи и продажи",
    "рост стоимости на 10–20% (в зависимости от объекта)",
    "презентация объекта в лучшем свете",
    "снижение времени простоя квартиры",
  ],
};


export const servicesSection = {
  title: "Мои услуги",
  pricesLabel: "Цены",
  dropdownLabel: "Студия",
  cta: "Обсудить",
  cards: [
    {
      key: "new",
      title: "Полная комплектация пустой квартиры с ремонтом от застройщика",
      desc: "Для квартир со строительным ремонтом без мебели.",
      bullets: [
        "Комплектация, меблировка и декорирование под ключ.",
        "2D дизайн-проект каждой комнаты.",
        "План расстановки мебели.",
        "Подбор мебели, текстиля, декора и техники — со ссылками и ценами.",
        "Полный контроль всех процессов, включая приём товаров на объекте, сборку мебели и установку техники.",
        "Профессиональная фотосъёмка интерьера для размещения на досках объявлений.",
      ],
    },
    {
      key: "old",
      title: "Частичное декорирование уже обустроенной квартиры",
      desc: "Для квартир с ремонтом и мебелью.",
      bullets: [
        "Точечные улучшения без полноценного ремонта.",
        "Эргономичная расстановка мебели, удаление лишних предметов.",
        "Декорирование: добавление текстиля (занавески, покрывала и т.п.) или аксессуаров.",
        "При необходимости — закупка отдельных предметов мебели и декора.",
        "Профессиональная фотосъёмка интерьера для размещения объекта на досках объявлений.",
      ],
    },
    {
      key: "online",
      title: "Онлайн проект",
      desc: "Инструкция «сделай сам», разработанная\nиндивидуально для вашей квартиры",
      bullets: [
        "В получаете 2D дизайн-проект каждой комнаты.",
        "И смету со ссылками на товары, указанные в\nпроекте: мебель, текстиль, элементы декора.",
        "Далее вы реализуете проект самостоятельно.",
        "Онлайн-поддержка в течение 4-х недель.",
      ],
    },
  ],
};

export const portfolio = {
  title: "Объекты",
  cards: [
    {
      id: "kedrova-1",
      title: "Улица Кедрова, Москва (ЮЗАО) — квартира под сдачу",
      desc: "Сдана за 110 000 руб. Аналог в этом же доме сдаётся за 85 000 руб.",
      badgeTime: "20 дней",
      badgeCost: "740 000 ₽",
      beforeLabel: "До",
      afterLabel: "После",
      payoffLine: "Стейджинг: 740 тыс. Разница в арендной ставке: +25 000 ₽/мес. Окупаемость: ~2,5 года.",
      beforeUrl: "/portfolio/kedrova/kedrova-do-1.jpg",
      afterUrl: "/portfolio/kedrova/kedrova-posle-1.jpg",
      photos: [],
      photoSections: [
        {
          label: "До",
          urls: [
            "/portfolio/kedrova/kedrova-do-1.jpg",
            "/portfolio/kedrova/kedrova-do-2.jpg",
            "/portfolio/kedrova/kedrova-do-3.jpg",
          ],
        },
        {
          label: "После",
          urls: [
            "/portfolio/kedrova/kedrova-posle-1.jpg",
            "/portfolio/kedrova/kedrova-posle-2.jpg",
            "/portfolio/kedrova/kedrova-posle-3.jpg",
            "/portfolio/kedrova/kedrova-posle-4.jpg",
            "/portfolio/kedrova/kedrova-posle-5.jpg",
            "/portfolio/kedrova/kedrova-posle-6.jpg",
          ],
        },
      ],
    },
    {
      id: "novaya-zvezda-1",
      title: "ЖК «Новая Звезда», Коммунарка — квартира под сдачу",
      desc: "Частичное декорирование обустроенной квартиры.",
      badgeTime: "25 дней",
      badgeCost: "950 000 ₽",
      beforeLabel: "До",
      afterLabel: "После",
      payoffLine: "",
      beforeUrl: "/portfolio/novaya-zvezda/before.jpg",
      afterUrl: "/portfolio/novaya-zvezda/after-1.jpg",
      photos: [
        "/portfolio/novaya-zvezda/before.jpg",
        "/portfolio/novaya-zvezda/after-1.jpg",
      ],
    },
    {
      id: "mock-2",
      title: "ЖК «Березки», Москва (ЮАО) — квартира под сдачу",
      desc: "После стейджинга квартира сдана за 145 000 руб. Аналоги: 110 000 руб.",
      badgeTime: "10 дней",
      badgeCost: "~400 000 ₽",
      beforeLabel: "До",
      afterLabel: "После",
      payoffLine: "Стейджинг: 400 тыс. Окупаемость: ~8 месяцев.",
      beforeUrl: "",
      afterUrl: "",
      photos: [],
    },
    {
      id: "mock-3",
      title: "ЖК «Березки», Москва (ЮАО) — квартира под сдачу",
      desc: "После стейджинга квартира сдана за 145 000 руб. Аналоги: 110 000 руб.",
      badgeTime: "10 дней",
      badgeCost: "~400 000 ₽",
      beforeLabel: "До",
      afterLabel: "После",
      payoffLine: "Стейджинг: 400 тыс. Окупаемость: ~8 месяцев.",
      beforeUrl: "",
      afterUrl: "",
      photos: [],
    },
  ],
};

export const dummyImages = {
  beforeUrl: "/dummy/before.jpg",
  afterUrl: "/dummy/after.jpg",
};


// legacy exports kept for now (unused in slides layout)
export const cases = [
  {
    id: "pik",
    title: "Студия ПИК с отделкой",
    result:
      "Под аренду: усилили свет, добавили функциональную мебель и «чистый» кадр для объявлений.",
    investment: "Комплектация и стейджинг в рамках согласованного бюджета.",
    timing: "7–12 дней",
    cost: "от 120 000 ₽",
    beforeLabel: "До",
    afterLabel: "После",
  },
  {
    id: "berezki",
    title: "ЖК «Березки», Москва (ЮАО)",
    result:
      "Аналоги — 100 тыс/мес. После стейджинга квартира сдана за 145 тыс/мес.",
    investment: "Стейджинг: 400 тыс. Окупаемость: ~8 месяцев.",
    timing: "10 дней",
    cost: "~400 000 ₽",
    beforeLabel: "До",
    afterLabel: "После",
  },
  {
    id: "developer",
    title: "Квартира с отделкой от застройщика",
    result:
      "Сделали уютнее и «дороже» на вид: текстиль, свет, декор, правильные акценты.",
    investment: "Бюджет подбирается под цель: аренда или продажа.",
    timing: "7–14 дней",
    cost: "от 180 000 ₽",
    beforeLabel: "До",
    afterLabel: "После",
  },
  {
    id: "compact",
    title: "Небольшая студия под аренду",
    result:
      "Максимум функционала и визуальной чистоты — чтобы на фото «цепляло» с первого кадра.",
    investment: "Оптимизируем расходы: недорого, но качественно.",
    timing: "5–9 дней",
    cost: "от 120 000 ₽",
    beforeLabel: "До",
    afterLabel: "После",
  },
];

export const pricing = [
  {
    tier: "Онлайн‑проект",
    price: "25–60 тыс ₽",
    time: "3–7 дней",
    includes: ["план + палитра", "смета со ссылками", "1 созвон"],
  },
  {
    tier: "Комплектация под ключ",
    price: "150–600 тыс ₽",
    time: "1–3 недели",
    includes: ["закупка и логистика", "сборка/монтаж", "стилизация + фото"],
  },
  {
    tier: "Вторичка (освежение)",
    price: "120–450 тыс ₽",
    time: "5–14 дней",
    includes: ["точечные улучшения", "декор/свет/текстиль", "подготовка к показам"],
  },
];

export const processSteps = [
  {
    title: "Короткий созвон или вы заполняете форму на сайте",
    desc: "Вы описываете свою задачу.",
    deliverable: "",
  },
  {
    title: "Встреча на объекте",
    desc: "Оцениваем помещение и задачи клиента. Оцениваем приблизительный бюджет исходя из задач.",
    deliverable: "",
  },
  {
    title: "Предлагаю концепцию и дизайн-проект",
    desc: "Составляю общий бюджет.",
    deliverable: "",
  },
  {
    title: "Реализация",
    desc: "Закупки, доставка, сборка, расстановка, декорирование, финальная фотосъёмка.",
    deliverable: "",
  },
];

export const faq = [
  {
    q: "Сколько стоит хоумстейджинг?",
    a: "Стоимость зависит от цели (аренда/продажа), метража, состояния и объема закупок. Я работаю с понятными диапазонами и фиксирую смету до старта.",
  },
  {
    q: "Можно ли сделать вау‑эффект без капитального ремонта?",
    a: "Да. Чаще всего достаточно света, текстиля, декора, правильной палитры и функциональной мебели. Я делаю упор на «впечатление» и фото‑привлекательность.",
  },
  {
    q: "Сколько времени занимает подготовка?",
    a: "Типовой проект — от 5 дней до 3 недель. Срок зависит от объема закупок и доступности товаров.",
  },
  {
    q: "Вы работаете только в Москве?",
    a: "Очные проекты — в Москве и ближайшем Подмосковье. Онлайн‑проект возможен в любом городе.",
  },
];

// Blog default structure (required for deepMerge to work correctly)
export const blog = {
  enabled: true,
  posts: [
    {
      id: "kedrova-case",
      slug: "kedrova-kvartira-pod-sdashu",
      title: "Улица Кедрова, ЮЗАО: комплектация пустой квартиры под сдачу в аренду",
      excerpt: "Квартира от застройщика без мебели. Задача — полная комплектация под сдачу в аренду. Срок: 20 дней. Результат: сдана за 110 000 руб. при аналогах за 85 000 руб.",
      published: true,
      publishedAt: "2026-02-17T00:00:00.000Z",
      photos: [
        "/portfolio/kedrova/kedrova-do-1.jpg",
        "/portfolio/kedrova/kedrova-posle-1.jpg",
        "/portfolio/kedrova/kedrova-do-2.jpg",
        "/portfolio/kedrova/kedrova-posle-2.jpg",
        "/portfolio/kedrova/kedrova-do-3.jpg",
        "/portfolio/kedrova/kedrova-posle-3.jpg",
        "/portfolio/kedrova/kedrova-posle-4.jpg",
        "/portfolio/kedrova/kedrova-posle-5.jpg",
        "/portfolio/kedrova/kedrova-posle-6.jpg",
      ],
      content: "Задача: комплектация пустой квартиры с ремонтом от застройщика под сдачу в аренду.\n\nКвартира находится в ЮЗАО Москвы, улица Кедрова. Собственник приобрёл её как инвестицию и хотел сдать как можно быстрее и дороже.\n\nЧто было сделано:\n— 2D дизайн-проект каждой комнаты\n— Подбор мебели, текстиля, декора и техники со ссылками и ценами\n— Полный контроль всех процессов: приём товаров на объекте, сборка мебели, установка техники\n— Профессиональная фотосъёмка интерьера\n\nСрок реализации: 20 дней.\nБюджет комплектации: 740 000 руб.\n\nРезультат: квартира сдана за 110 000 руб./мес. Аналогичные квартиры в том же доме сдаются за 85 000 руб. Разница в арендной ставке — 25 000 руб./мес. Окупаемость стейджинга — около 2,5 лет за счёт повышенной ставки.",
      socialLinks: {},
    },
  ],
};
